"use client";

import React, {useRef} from "react";
import {Box, Fade} from "@mui/material";
import useEmbeddedHtml from "@/hooks/use-embedded-html/use-embedded-html";
import CrowdRiffGallerySkeleton from "@/components/common/crowdriff-gallery/crowd-riff-gallery.skeleton";

interface CrowdRiffSectionProps {
  scriptId: string;
  src: string;
}

const CrowdRiffGallery = ({
  scriptId,
  src
}: CrowdRiffSectionProps) => {
  const targetRef = useRef<HTMLElement>(null);
  const { isLoading } = useEmbeddedHtml({
    targetElementRef: targetRef,
    scriptId,
    src,
    async: true
  });

  if (isLoading) {
    return <Fade><CrowdRiffGallerySkeleton /></Fade>;
  }

  return <Box
    id="cr-gallery_container"
    data-testid="cr-gallery_container"
    ref={targetRef}
  />;
};

export default CrowdRiffGallery;